"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const common = (0, styled_components_1.css) `
  position: absolute;
  display: block;
  width: ${({ theme }) => theme.arrowSize};
  height: ${({ theme }) => theme.arrowSize};

  background: inherit;
  border: inherit;
`;
const Arrow = styled_components_1.default.div `
  visibility: hidden;
  ${common}

  &::before {
    content: '';
    visibility: visible;
    transform: rotate(45deg);
    ${common}
  }

  &[data-placement*='bottom'],
  &[data-placement*='bottom']::before {
    border-top-left-radius: ${({ theme }) => theme.arrowBorderRadius};
  }

  &[data-placement*='top'],
  &[data-placement*='top']::before {
    border-bottom-right-radius: ${({ theme }) => theme.arrowBorderRadius};
  }

  &[data-placement*='right'],
  &[data-placement*='right']::before {
    border-bottom-left-radius: ${({ theme }) => theme.arrowBorderRadius};
  }

  &[data-placement*='left'],
  &[data-placement*='left']::before {
    border-top-right-radius: ${({ theme }) => theme.arrowBorderRadius};
  }
`;
Arrow.displayName = 'Arrow';
exports.default = Arrow;
